import { render, staticRenderFns } from "./new-techprovider-form.vue?vue&type=template&id=399d62f3&"
import script from "./new-techprovider-form.vue?vue&type=script&lang=js&"
export * from "./new-techprovider-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports